import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  message,
  Button,
  Tooltip,
  Popover,
  Spin,
  Divider,
  Input,
  Popconfirm,
  Alert,
  Table,
  notification,
  Upload,
  Icon,
} from "antd";
import Basil from "basil.js";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { API, Storage } from "aws-amplify";
import { Container } from "./styled";
import Papa from "papaparse";

const CreateCSVOrder = ({ user }) => {
  const [rows, setRows] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onFileSelect = file => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (result) => {
        setRows(result.data);
        if (!mappings.length) {
          setLoading(true);
          const { results } = await API.get("api", "mappings", { queryStringParameters: { limit: 0 }});
          setMappings(results);
          resolveRowMappings(result.data, results);
          setLoading(false);
        } else {
          resolveRowMappings(result.data, mappings);
        }
      },
    });
    return false;
  };

  const resolveRowMappings = (rows, mappings) => {
    setRows(rows.map(row => {
      const mapping = mappings.find(mapping => mapping.name === row.mapping_name);
      if (mapping) {
        row.mapping = mapping;
      }
      return row;
    }));
  }

  const onRestart = () => {
    setRows([]);
    setDone(false);
  }

  const onRemoveFile = () => {
    setRows([]);
  }

  const onSubmitOrder = async () => {
    setLoading(true);
    const orderItems = [];
    rows.forEach((row, index) => {
      if (row.mapping) {
        orderItems.push({
          row,
          index
        });
      }
    });
    for (const orderItem of orderItems) {
      const { row, index } = orderItem;
      try {
        const resp = await API.post("api", "orders/bulk", {
          body: {
            shipping: row.ship_method,
            orderReference: row.job_ref_id,
            deliveryAddress: {
              firstName: row.ship_firstName,
              lastName: row.ship_lastName,
              line1: row.addr_line1,
              line2: row.addr_line2,
              city: row.city,
              state: row.state,
              zip: row.zip,
            },
            returnAddress: user.address,
            items: [{
              mappingId: row.mapping.id,
              quantity: row.quantity
            }],
          }
        });
        rows[index].order = resp;
      } catch (error) {
        rows[index].error = error.response.data.message;
      }
    }
    setLoading(false);
    setDone(true);
  }

  const columns = [
    { title: 'mapping_name', dataIndex: 'mapping_name'},
    { title: 'quantity', dataIndex: 'quantity'},
    { title: 'job_ref_id', dataIndex: 'job_ref_id'},
    { title: 'ship_method', dataIndex: 'ship_method'},
    { title: 'ship_firstName', dataIndex: 'ship_firstName'},
    { title: 'ship_lastName', dataIndex: 'ship_lastName'},
    { title: 'addr_line1', dataIndex: 'addr_line1'},
    { title: 'addr_line2', dataIndex: 'addr_line2'},
    { title: 'city', dataIndex: 'city'},
    { title: 'state', dataIndex: 'state'},
    { title: 'zip', dataIndex: 'zip'},
    { title: 'Valid', dataIndex: 'mapping', render: (mapping) => {
      if (!mapping) {
        return (
          <Tooltip title="Mapping not found. Please verify mapping name">
            <Icon type="close-circle" style={{ color: 'red'}} />
          </Tooltip>
        )
      }
      return <Icon type="check" style={{ color: 'green'}} />
    }},
    { title: 'Order status', dataIndex: 'order', render: (order, row) => {
      if (!row.mapping) return 'Skipped';
      if (!done) return 'Pending';
      if (row.error) {
        return (
          <>
            <Icon type="close-circle" style={{ color: 'red'}} /> {row.error}
          </>
        )
      }
      return (
        <>
          <Icon type="check" style={{ color: 'green'}} /> {order.orderId} created
        </>
      )
    }}
  ];
  if (done) {
    return (
      <Container>
        <Helmet title="Order complete" />
        <h3>Order Status</h3>
        <Table
          loading={loading}
          rowKey={(row, i) => i}
          pagination={false}
          dataSource={rows}
          columns={columns} />
        <br/>
        <Button type="primary" size="large" onClick={onRestart}>Place new order</Button>
      </Container>
    )
  }

  return (
    <Container>
      <Helmet title="Create order from CSV file" />
      <p>
        Create csv order from a csv file. The csv file should have the following
      </p>
      <Alert message={
        <>
          <p>
            CSV must have following column headers mapping_name,quantity,job_ref_id,ship_method,ship_firstName,ship_lastName,addr_line1,addr_line2,city,state,zip
          </p>
          <a href="/bulk-order-csv-template.csv">Download template csv</a>
        </>
      } type="info" showIcon />
      <br/>
      <div>
        <Upload
          listType="picture-card"
          accept=".csv"
          beforeUpload={onFileSelect}
          onRemove={onRemoveFile}
        >
          <Button ghost icon="upload" size="large" type="primary">
            Select CSV File
          </Button>
        </Upload>
      </div>

      <div>
        { rows.length ? (
          <Table
            loading={loading}
            rowKey={(row, i) => i}
            pagination={false}
            dataSource={rows}
            columns={columns} />
        ) : null}
      </div>
      <br/>
      { rows.length ? (
        <Popconfirm title="Confirm?" onConfirm={onSubmitOrder}>
          <Button loading={loading} type="primary" size="large" color="primary">Submit Order</Button>
        </Popconfirm>
      ) : null}
    </Container>
  )
};

export default connect(s => s.session)(CreateCSVOrder);